import React from 'react';
import { AlertTriangle } from 'lucide-react';
import './UserFormCoordinatorUnlinkModal.css';

/**
 * Aviso bloqueante ao tentar tirar o tipo Coordenador com vínculos em Gestão de equipe.
 */
export function UserFormCoordinatorUnlinkModal({
  message,
  hasAreaLinks = false,
  hasTeamLinks = false,
  title = 'Operação bloqueada',
  onClose,
}) {
  if (!message && !hasAreaLinks && !hasTeamLinks) return null;

  return (
    <div className="uf-coord-unlink-overlay" role="dialog" aria-modal="true" aria-labelledby="uf-coord-unlink-title">
      <div className="uf-coord-unlink-modal">
        <div className="uf-coord-unlink-icon" aria-hidden>
          <AlertTriangle size={22} strokeWidth={1.75} />
        </div>
        <h3 id="uf-coord-unlink-title" className="uf-coord-unlink-title">
          {title}
        </h3>
        <p className="uf-coord-unlink-lead">
          Não é possível alterar ou excluir este coordenador enquanto houver vínculos em{' '}
          <strong>Gestão de equipe</strong>.
        </p>
        <ul className="uf-coord-unlink-list">
          {hasAreaLinks ? (
            <li>Retire as áreas vinculadas a este coordenador.</li>
          ) : null}
          {hasTeamLinks ? (
            <li>Retire os técnicos das áreas deste coordenador.</li>
          ) : null}
          {!hasAreaLinks && !hasTeamLinks && message ? <li>{message}</li> : null}
        </ul>
        <div className="uf-coord-unlink-actions">
          <button
            type="button"
            className="user-form-profile-save-btn user-form-footer-btn"
            onClick={onClose}
          >
            Entendi
          </button>
        </div>
      </div>
    </div>
  );
}
